const contractorProjectsFiltersTemplate = {
  startDate: "",
  endDate: "",
  createdAt: "",
  title: "",
  location: "",
  managers: [],
};

export default contractorProjectsFiltersTemplate;